import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import BrandBlogArticlePage from './BrandBlogArticlePage';

export default function BlogArticlePage() {
  return (
    <>
      <Navbar />
      <BrandBlogArticlePage
        publisher="複刻文化"
        brandName="複刻文化"
        englishName="FUKO"
      />
      <Footer />
    </>
  );
}
